import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spaceTransform'
})
export class SpaceTransformPipe implements PipeTransform {

  transform(value: string): string {
    return '\t\n'+value+'\t\n';
  }

}
